export const InventorySvedItemPluginSettings: IPluginSettings = {
    name: "Позиции сводной ведомости",
    mnemocode: "inventory_sved_item_plugin",
    permission: "InventorySved",
    columns: [
        {
            order: 0,
            propertyName: "idGlobal",
            propertyType: "string",
            displayName: "ИД",
            visibility: false,
            width: 200,
        },
        {
            order: 1,
            propertyName: "idDocumentGlobal",
            propertyType: "string",
            displayName: "idDocumentGlobal",
            visibility: false,
            width: 200,
        },
        {
            order: 2,
            propertyName: "inventoryVedName",
            propertyType: "string",
            displayName: "Инвентаризационна ведомость",
            visibility: true,
            width: 200,
        },
        {
            order: 3,
            propertyName: "supplierSum",
            propertyType: "number",
            displayName: "Сумма, пост.",
            visibility: true,
            width: 200,
        },
        {
            order: 4,
            propertyName: "supplierVatSum",
            propertyType: "number",
            displayName: "Сумма НДС, пост.",
            visibility: true,
            width: 70,
        },
        {
            order: 5,
            propertyName: "supplierSumIncVat",
            propertyType: "number",
            displayName: "Сумма с НДС, пост.",
            visibility: true,
            width: 70,
        },
        {
            order: 6,
            propertyName: "retailSum",
            propertyType: "number",
            displayName: "Сумма, розн.",
            visibility: true,
            width: 70,
        },
        {
            order: 7,
            propertyName: "retailVatSum",
            propertyType: "number",
            displayName: "Сумма НДС, розн.",
            visibility: true,
            width: 70,
        },
        {
            order: 8,
            propertyName: "retailSumIncVat",
            propertyType: "number",
            displayName: "Сумма с НДС, розн.",
            visibility: true,
            width: 70,
        },
        {
            order: 9,
            propertyName: "dateCreated",
            propertyType: "date",
            displayName: "Дата создания",
            visibility: true,
            width: 100,
        },
        
    ],
    detailsPlugins: [],
};